import billingPaymentMethod from "~/schemas/schema.billingPaymentMethod.jsx";
import * as actionTypes from "~/store/action_types";
import Angie from "~/utils/angie.jsx";
import { fetch } from "~/utils/fetch.jsx";

export const fetchBillingPaymentMethod = () => {
  return {
    types: [
      actionTypes.FETCH_BILLING_PAYMENT_METHOD_LOADING,
      actionTypes.FETCH_BILLING_PAYMENT_METHOD_SUCCESS,
      actionTypes.FETCH_BILLING_PAYMENT_METHOD_ERROR,
    ],
    callAPI: () =>
      fetch({
        url: `${Angie.api_url}/subscription/payment-method`,
      }),
    payload: {
      schema: {
        single: billingPaymentMethod,
      },
    },
  };
};

export const addBillingPaymentMethod = (attributes) => {
  return {
    types: [
      actionTypes.ADD_BILLING_ADDRESS_LOADING,
      actionTypes.ADD_BILLING_ADDRESS_SUCCESS,
      actionTypes.ADD_BILLING_ADDRESS_ERROR,
    ],
    callAPI: () =>
      fetch({
        url: `${Angie.api_url}/subscription/payment-method`,
        method: `POST`,
        body: attributes,
      }),
    payload: {
      attributes,
    },
  };
};

export const editBillingPaymentMethod = (attributes) => {
  return {
    types: [
      actionTypes.EDIT_BILLING_ADDRESS_LOADING,
      actionTypes.EDIT_BILLING_ADDRESS_SUCCESS,
      actionTypes.EDIT_BILLING_ADDRESS_ERROR,
    ],
    callAPI: () =>
      fetch({
        url: `${Angie.api_url}/subscription/payment-method`,
        method: `PUT`,
        body: attributes,
      }),
    payload: {
      attributes,
    },
  };
};

export const taxRatesCheck = (attributes) => {
  return {
    types: [
      actionTypes.TAX_RATES_CHECK_LOADING,
      actionTypes.TAX_RATES_CHECK_SUCCESS,
      actionTypes.TAX_RATES_CHECK_ERROR,
    ],
    callAPI: () =>
      fetch({
        url: `${Angie.api_url}/subscription/payment-method/tax-rates-check`,
        method: `POST`,
        body: attributes,
      }),
  };
};

export const setPaymentMethodType = (paymentMethodType) => {
  return {
    type: actionTypes.SET_PAYMENT_METHOD_TYPE,
    paymentMethodType,
  };
};
